import { CloseIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import { BoardType, IBoardMenu } from "app/types";
import clsx from "clsx";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getBoardIconIcon } from "../../containers/Home/containers/helpers";
import { ticketGroupsActions } from "../../containers/Tickets/redux/slice";
import { actions } from "../../redux/slice";
import { useBoardsActions } from "../useBoardsActions";
import { useBoardFormChanged } from "../Settings/helper";
import { actions as boardsActions } from "app/containers/Features/containers/Boards/components/Settings/redux/slice";

interface IVisibleBoardsProps {
  data: IBoardMenu[];
  selectedBoardId: string | null;
}

const VisibleBoards: React.FC<IVisibleBoardsProps> = ({
  data,
  selectedBoardId,
}) => {
  const params = useParams();
  const { project, team } = params;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isFormChanged = useBoardFormChanged();
  const { fetchBoardDetails } = useBoardsActions(params?.project as string);

  const handleCloseTab = (id: string) => {
    dispatch(
      actions.boardTabClose({
        id: id,
        callback() {},
      }),
    );
    navigate(`/app/${project}/${team}/boards`);
  };
  const handleNavigate = (data: IBoardMenu) => {
    if (isFormChanged) {
      dispatch(boardsActions.toggleBoardDraftFormModal(true));
      return;
    }
    dispatch(actions.resetSelectedTickets());
    dispatch(ticketGroupsActions.clearCreateTicket());
    const base = `/app/${params.project}/${params.team}/boards/${data.boardId}`;
    const path =
      data?.Type === BoardType.Backlog
        ? `${base}/backlog`
        : `${base}/${data?.viewType}/board`;
    navigate(path);
    fetchBoardDetails(data.boardId);
  };
  return (
    <React.Fragment>
      {data?.map((option) => (
        <div
          key={option._id}
          className={clsx(
            "bg-white relative flex flex-row items-center gap-2 px-4 uppercase text-sm font-normal text-secondary leading-5 py-2 hover:bg-gray-100 group cursor-pointer flex-shrink-0 min-w-0",
            {
              "border-b-2 border-primary": selectedBoardId === option?.boardId,
            },
          )}
          onClick={() => handleNavigate(option)}
        >
          {getBoardIconIcon(option, selectedBoardId === option.boardId)}
          <CustomTooltip
            text={option?.name}
            position="bottom"
            className="truncate max-w-[120px]"
            contentClassName="max-w-[443px]"
          >
            <span
              className={clsx("truncate", {
                "text-primary font-semibold":
                  selectedBoardId === option.boardId,
              })}
            >
              {option?.name}
            </span>
          </CustomTooltip>

          {option?.Type !== BoardType.Backlog && (
            <CustomTooltip
              text="Close tab"
              contentClassName="capitalize"
              position="bottom"
            >
              <button
                className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 bg-[#ECEEF2] rounded-md backdrop-blur-2xl hidden group-hover:flex items-center justify-center flex-shrink-0"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCloseTab(option?.boardId);
                }}
              >
                <CloseIcon color="#79808A" size="16" />
              </button>
            </CustomTooltip>
          )}
        </div>
      ))}
    </React.Fragment>
  );
};

export default VisibleBoards;
